import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import { Box, ButtonFilled, ButtonText, Flex, Image, Text } from 'Components/Base';
import Loading from 'Components/Loading';

import ImageGallery from '../ClearImageGallery';

const QuestionWrapper = styled((props) => <Box bg={'coolGrey.grey3'} {...props} />)`
  border-radius: 4px;
`;

const ClearTicketReview = ({
  bookNo,
  pageNo,
  question,
  questionNo,
  images,
  onBack = () => {},
  onSend = () => {},
  loading,
  ...props
}) => {
  const { t } = useTranslation('classroom');
  const hasImageGallery = !!(Array.isArray(images) && images.length);
  return (
    <Box {...props}>
      <Flex flexDirection={'column'} justifyContent={'center'} alignItems={'center'}>
        <Image src={'/assets/images/feedback/comment.svg'} maxWidth={'75px'} />
        <Text textStyle={'heading2'}>{t('CLEAR_BY_ONDEMAND.TICKET_REVIEW.TITLE')}</Text>
      </Flex>
      {hasImageGallery && (
        <Box mt={7}>
          <Text textStyle={'subtitle1'}>
            {t('CLEAR_BY_ONDEMAND.TICKET_REVIEW.IMAGE_SECTION_TITLE')}
          </Text>
          <ImageGallery mt={3} images={images} />
        </Box>
      )}
      <Box mt={hasImageGallery ? 4 : 7}>
        <Text textStyle={'subtitle1'}>{t('CLEAR_BY_ONDEMAND.TICKET_REVIEW.QUESTION_TITLE')}</Text>
        <QuestionWrapper mt={3} py={4} px={5}>
          <Text>{question}</Text>
        </QuestionWrapper>
      </Box>
      <Box mt={4}>
        <Text textStyle={'subtitle1'}>
          {t('CLEAR_BY_ONDEMAND.TICKET_REVIEW.DETAIL_QUESTION.TITLE')}
        </Text>
        <Flex justifyContent={'space-between'} mt={3}>
          <Text>{t('CLEAR_BY_ONDEMAND.TICKET_REVIEW.DETAIL_QUESTION.BOOK_NO')}</Text>
          <Text textStyle={'body1Medium'}>{bookNo}</Text>
        </Flex>
        <Flex justifyContent={'space-between'} mt={5}>
          <Text>{t('CLEAR_BY_ONDEMAND.TICKET_REVIEW.DETAIL_QUESTION.PAGE_NO')}</Text>
          <Text textStyle={'body1Medium'}>{pageNo}</Text>
        </Flex>
        <Flex justifyContent={'space-between'} mt={5}>
          <Text>{t('CLEAR_BY_ONDEMAND.TICKET_REVIEW.DETAIL_QUESTION.QUESTION_NO')}</Text>
          <Text textStyle={'body1Medium'}>{questionNo}</Text>
        </Flex>
      </Box>
      <Flex flexDirection={'column'} mt={8}>
        <ButtonFilled onClick={onSend} disabled={loading}>
          {loading ? (
            <Loading width={20} height={20} />
          ) : (
            t('CLEAR_BY_ONDEMAND.TICKET_REVIEW.SEND_QUESTION')
          )}
        </ButtonFilled>
        <ButtonText onClick={onBack} disabled={loading}>
          {t('CLEAR_BY_ONDEMAND.TICKET_REVIEW.EDIT_QUESTION')}
        </ButtonText>
      </Flex>
    </Box>
  );
};

ClearTicketReview.propTypes = {
  bookNo: PropTypes.number,
  pageNo: PropTypes.number,
  question: PropTypes.string,
  questionNo: PropTypes.number,
  onBack: PropTypes.func,
  onSend: PropTypes.func,
  ...ImageGallery.propTypes,
};

export default ClearTicketReview;
